// extracted by mini-css-extract-plugin
export default {"bigTitle":"styles_bigTitle__uftRx","modalEditBar":"styles_modalEditBar__0U1V5","a":"styles_a__a3iuz","button":"styles_button__itD9Z","primary":"styles_primary__jn2QB"};